import PrintsGallery from './PrintsGallery';

export default PrintsGallery;
